import { render, staticRenderFns } from "./skillbubble.vue?vue&type=template&id=12906acc&scoped=true&"
import script from "./skillbubble.vue?vue&type=script&lang=js&"
export * from "./skillbubble.vue?vue&type=script&lang=js&"
import style0 from "./skillbubble.vue?vue&type=style&index=0&id=12906acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12906acc",
  null
  
)

export default component.exports